const differenceWith=(comparator,array,...args)=>{const union=args.reduce((acc,curr)=>acc.concat(curr),[]);return array.filter(el=>union.every(x=>!comparator(el,x)))};export{differenceWith};
